import { forwardRef, useImperativeHandle, useRef } from 'react';
import { SectionLabel } from '@/components/ui/section-label';
import { Card } from '@/components/ui/card/Card';

import { DropDownList } from '@/components/form/inputs/DropDownList';
import { SimpleInput } from '@/components/form/inputs/SimpleInput';
import { useTranslation } from '@/hooks/useTranslation';
import { Link2 } from 'lucide-react';

import { toolHolderTypes } from '../../data/toolHolderOptions';

type HolderTabProps = {
  values: Record<string, unknown>;
  onChange: (name: string, value: unknown) => void;
};

export const HolderTab = forwardRef(function HolderTab({ values, onChange }: HolderTabProps, ref) {
  const input1Ref = useRef<{ validate: () => boolean }>(null);
  const input2Ref = useRef<{ validate: () => boolean }>(null);
  const { t } = useTranslation();
  useImperativeHandle(ref, () => ({
    validate: () => {
      const v1 = input1Ref.current?.validate() ?? true;
      const v2 = input2Ref.current?.validate() ?? true;

      return v1 && v2;
    },
  }));
  return (
    <div className="grid grid-cols-1 gap-5">
      <Card padding="sm">
        <div className="flex flex-col gap-2">
          <div className="space-y-1">
            <SectionLabel icon={Link2}>
              {t('traceability.holderTab.title')}
            </SectionLabel>
            <p className="text-sm text-muted-foreground">{t('traceability.holderTab.description')}</p>
          </div>
          <div className="mt-3 grid gap-3 md:grid-cols-2">
            <DropDownList
              ref={input1Ref}
              name="holderType"
              label={t('traceability.holderTab.typeLabel')}
              value={(values['holderType'] as string) ?? ''}
              onChange={(val) => onChange('holderType', val)}
              options={toolHolderTypes.map(({ value, labelKey }) => ({
                value,
                label: t(labelKey),
              }))}
              side="bottom"
            />
            <SimpleInput
              ref={input2Ref}
              name="holderBrand"
              label={t('traceability.holderTab.brandLabel')}
              value={(values['holderBrand'] as string) ?? ''}
              onChange={(val) => onChange('holderBrand', val)}
              placeholder={t('traceability.holderTab.brandPlaceholder')}
            />
          </div>
        </div>
      </Card>
    </div>
  );
});
